import makeApiCall from "./master/axiosIndex";

export type PmsDashboardParams = {
  siteIds?: string | number;
  projectIds?: string | number;
  phaseIds?: string | number;
  activityIds?: string | number;
  page?: number;
  pageSize?: number;
  type?: string;
};

const cleanPmsParams = (params?: PmsDashboardParams): Record<string, any> => {
  const cleaned: Record<string, any> = {};
  if (!params) return cleaned;
  Object.keys(params).forEach((key) => {
    const value = (params as any)[key];
    if (value !== undefined && value !== null && value !== "") {
      cleaned[key] = value;
    }
  });
  return cleaned;
};

export const dashboardPMSApis = {
  fetchPlannedVsDeviatedTasks: (
    projectIds: number,
    reportName: string,
    endDate: any
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/plannedVsDeviatedTasksDashBoard`,
      method: "get",
      params: { projectIds, reportName, endDate },
    });
  },
  fetchProjectCompletionStatus: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/projectCompletionStatusDashBorad`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchOverDueTaskOnGoing: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/overDueTaskOnGoingDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchTaskProgress: (projectIds: number, reportName: string): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/taskProgressDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchPlannedVsActualDashBoard: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/taskplannedVsActualDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchIssueStatusDashBoard: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/issueStatusDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchWeeklyDigestDropdown: (projectId: number): Promise<any> => {
    return makeApiCall({
      url: `/project/weekRange/dropdown`,
      method: "get",
      params: { projectId },
    });
  },
  fetchWeeklyDigest: (
    projectIds: number,
    reportName: string,
    startDate: any,
    endDate: any
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/weeklyDigestDashBoard`,
      method: "get",
      params: { projectIds, reportName, startDate, endDate },
    });
  },
  fetchIssueFixersData: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/topFiveIssueFixersDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchTopFiveGoGettersOrAssgigned: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/topFiveGoGettersOrAssgignedDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchPhaseLevelStatusDashboar: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/phaseLevelStatusDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchTaskSummaryDashBoard: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/taskSummaryDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchTeamStatusDashboard: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/teamStatusDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchIssueStatusByTeamMemberDashBoard: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/issueStatusByTeamMemberDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchOverDueWorkItemsDashBoard: (
    projectIds: number,
    reportName: string
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/overDueWorkDashBoard`,
      method: "get",
      params: { projectIds, reportName },
    });
  },
  fetchPhaseLevelStatusDashBoard: (
    projectIds: number,
    reportName: string,
    phaseIds: any
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms-reports/phaseLevelStatusDashBoard`,
      method: "get",
      params: { projectIds, reportName, phaseIds },
    });
  },
  fetchPhaseDropdown: (projectId: number): Promise<any> => {
    return makeApiCall({
      url: `/phase/dropdown`,
      method: "get",
      params: { projectId },
    });
  },
  fetchExecutiveSummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/executive-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },

  // 2. Project Management Analytics
  fetchProjectAnalyticsGraph: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/project-analytics-graph`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchProjectAnalyticsTabular: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/project-analytics-tabular`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchProjectKpiSummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/project-kpi-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchProjectPhaseDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/project-phase-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchProjectActivityDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/project-activity-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchProjectTaskDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/project-task-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },

  // 3. Procurement & Payables
  fetchProcurementPayablesGraph: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/procurement-payables-graph`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchProcurementPayablesTabular: (
    params?: PmsDashboardParams
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/procurement-payables-tabular`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchPoSummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/po-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchPoDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/po-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchInvoiceSummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/invoice-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchInvoiceDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/invoice-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchInvoiceAgingSummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/invoice-aging-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchInvoiceAgingDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/invoice-aging-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },

  // 4. Inventory Analytics
  fetchInventorySummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/inventory-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchInventoryShortageDetails: (
    params?: PmsDashboardParams
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/inventory-shortage-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchInventoryOverstockDetails: (
    params?: PmsDashboardParams
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/inventory-overstock-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchInventoryStockAgeDetails: (
    params?: PmsDashboardParams
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/inventory-stock-age-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchInventoryTurnoverDetails: (
    params?: PmsDashboardParams
  ): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/inventory-turnover-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },

  // 5. Work Order & RA Bills
  fetchWoRaBillsGraph: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/wo-ra-bills-graph`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchWoRaBillsTabular: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/wo-ra-bills-tabular`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchWoDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/wo-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchRaBillsPayableSummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/ra-bills-payable-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchRaBillsPayableDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/ra-bills-payable-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchRaBillsAgingSummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/ra-bills-aging-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchRaBillsAgingDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/ra-bills-aging-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },

  // 6. Budget Analytics
  fetchBudgetSummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/budget-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchBudgetVarianceSummary: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/budget-variance-summary`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
  fetchBudgetVarianceDetails: (params?: PmsDashboardParams): Promise<any> => {
    return makeApiCall({
      url: `/pms/pms-main-dashboard/budget-variance-details`,
      method: "get",
      params: cleanPmsParams(params),
    });
  },
};
